import React, { useState } from "react";
import Table from "../../../core/common/dataTable/index";
import { getDisbursement } from "../../../apis/expences";
import { Link } from "react-router-dom";
import { updateVerificationById } from "../../../apis/customers";
import CommonSearch from "../commonSearch";

type EmiDetail = {
  empFinacerDetails: any;
  empRetailerDetails: any;
  id: number;
  customer_name: string;
  customerAccountNumber: string;
  loanAccountNumber: string;
  paymentAmount: number;
  paymentDate: string;
  paymentMode: string;
  penaltyAmount: number;
  status: string;
  vendorDetais: any;
  phoneNumber1: string;
  aadharNumber: string;
  groupName?: string;
  branchName?: string;
};

const PaymentCollection: React.FC = () => {
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [emiDetails, setEmiDetails] = useState<EmiDetail[]>([]);
  const [newData, setNewData] = useState<any>();
  const [totalPaymentAmount, setTotalPaymentAmount] = useState<number>(0);
  const [totalPenaltyAmount, setTotalPenaltyAmount] = useState<number>(0);
  const [totalDiscountAmount, setTotalDiscountAmount] = useState<number>(0);

  const getAllData = async (): Promise<void> => {
    const loginData = sessionStorage.getItem("info");
    const data = {
      start_date: startDate,
      end_date: endDate,
      user_id: JSON.parse(loginData).id,
      type: JSON.parse(loginData).type,
    };
    try {
      const response = await getDisbursement(data);
      let modPaymentDetails = [];
      let srNo = 0;
      response.data.forEach((item: { payments: any[]; customer: { full_name: any; loanAccountNumber: any; phoneNumber1: any; aadharNumber?: string; group?: { groupName?: string; }; retailer?: { company_name?: string; full_name?: string; }; }; loans: { loan_id: any; }; }) => {
        item.payments.map((payItems: { sr_no: number; customer_name: any; customerAccountNumber: any; loanAccountNumber: any; phoneNumber1: any; aadharNumber?: string; groupName?: string; branchName?: string; }) => {
          srNo = srNo + 1 || 0;
          payItems.sr_no = srNo;
          payItems.customer_name = item.customer.full_name;
          payItems.customerAccountNumber = item.customer.loanAccountNumber;
          payItems.loanAccountNumber = item.loans.loan_id;
          payItems.phoneNumber1 = item.customer.phoneNumber1;
          payItems.aadharNumber = item.customer.aadharNumber;
          payItems.groupName = item.customer.group?.groupName || "--";
          payItems.branchName = item.customer.retailer?.company_name || item.customer.retailer?.full_name || "--";
          modPaymentDetails = [...modPaymentDetails, payItems];
        });
      });


      const totalAmount = modPaymentDetails.reduce((sum, item) => sum + (item.paymentAmount || 0), 0);
      const totalPenalty = modPaymentDetails.reduce((sum, item) => sum + (item.penaltyAmount || 0), 0);
      const totalDiscount = modPaymentDetails.reduce((sum, item) => sum + (item.discount || 0), 0);

      setTotalPaymentAmount(totalAmount);
      setTotalPenaltyAmount(totalPenalty);
      setTotalDiscountAmount(totalDiscount);
      setEmiDetails(modPaymentDetails || []);
    } catch (error) {
      console.error("Error fetching EMI details:", error);
      setTotalPaymentAmount(0);
      setTotalPenaltyAmount(0);
    }
  };

  const columns = [
    {
      title: "SN no.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: (text: number) => `${text}`,
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
      render: (text: string) => `${text}`,
    },
    {
      title: "Group Name",
      dataIndex: "groupName",
      key: "groupName",
      render: (text: string) => text || "--",
    },
    {
      title: "Branch Name",
      dataIndex: "branchName",
      key: "branchName",
      render: (text: string) => text || "--",
    },
    {
      title: "Customer Account Number",
      dataIndex: "customerAccountNumber",
      key: "customerAccountNumber",
      render: (text: string) => `${text}`,
    },
    {
      title: "Loan Account Number",
      dataIndex: "loanAccountNumber",
      key: "loanAccountNumber",
      render: (text: string) => `${text}`,
    },
    {
      title: "Customer mobile Number",
      dataIndex: "phoneNumber1",
      key: "phoneNumber1",
      render: (text: string) => `${text}`,
    },
    {
      title: "Payment Amount",
      dataIndex: "paymentAmount",
      key: "paymentAmount",
      render: (text: number) => `₹ ${text}`,
    },
    {
      title: "Payment Date",
      dataIndex: "paymentDate",
      key: "paymentDate",
    },
    {
      title: "Penalty Amount",
      dataIndex: "penaltyAmount",
      key: "penaltyAmount",
    },
    {
      title: "Receiver Name",
      render: (record: EmiDetail) => {
        return record?.vendorDetais?.full_name || "--";
      },
    },
    {
      title: "Owner Name",
      render: (record: EmiDetail) =>
        record?.empRetailerDetails?.company_name ||
        record?.empFinacerDetails?.company_name ||
        record?.vendorDetais?.company_name ||
        "--",
    },
    {
      title: "Payment Mode",
      dataIndex: "paymentMode",
      key: "paymentMode",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text: string, record: EmiDetail) => (
        <span className="dropdown">
          <Link
            to="#"
            className={`badge  btn btn-white ${text === "verified" ? "badge-success" : "badge-danger"
              } d-inline-flex align-items-center badge-xs`}
            data-bs-toggle={record.status === "Unverified" ? "dropdown" : ""}
          >
            <i className="ti ti-point-filled me-1" />
            {text}
          </Link>
          <ul className="dropdown-menu dropdown-menu-end p-3">
            <li>
              <div
                className="dropdown-item rounded-1"
                data-bs-toggle="modal"
                data-bs-target="#status_modal"
                onClick={() =>
                  handleChangeStatus({
                    data: record,
                    status: "Verified",
                  })
                }
              >
                Verified
              </div>
            </li>
          </ul>
        </span>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: EmiDetail) => (
        <Link
          to={`/emis-records?aadhar=${encodeURIComponent(record.aadharNumber || "")}`}
          className="btn btn-outline-primary btn-sm"
        >
          EMI Records
        </Link>
      ),
    },
  ];

  const handleSubmit = (e: any) => {
    e.preventDefault();
    try {
      updateVerificationById(newData)
        .then((res) => getAllData())
        .catch((err) => alert("Data Not Exits"));

      getAllData();
    } catch (error) {
      console.error(error, "error");
    }
  };

  const handleChangeStatus = async (data: { data: any; status: string }) => {
    const payload = {
      status: data?.status,
      loanId: data?.data?.loanId,
      payment_id: data?.data?.id,
      customerId: data?.data?.customerId,
    };
    setNewData(payload);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="card">
            <div className="card-body p-0">
              <div className="card-header">
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                  <h3 className="mb-0">All Payment Record</h3>
                  <Link to="/emis-records" className="btn btn-primary">EMI Records</Link>
                </div>
                <div
                  className="me-3"
                  style={{ marginTop: "15px", width: "30%" }}
                >
                  <CommonSearch allEmployeeData={emiDetails} />
                </div>
                <div
                  style={{ display: "flex", gap: "1rem", marginTop: "15px" }}
                >
                  <div>
                    <label>Start Date</label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div>
                    <label>End Date</label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                  <button
                    className="btn btn-primary"
                    onClick={getAllData}
                    style={{ alignSelf: "flex-end" }}
                  >
                    Fetch Payment Details
                  </button>
                </div>
              </div>
            </div>
            <div className="card-body p-0">

              {emiDetails.length > 0 && (
                <div className="row">
                  <div className="col-3">
                    <div className="card bg-primary text-white">
                      <div className="card-body">
                        <h5 className="card-title">Total Payment Amount</h5>
                        <h2 className="mb-0">₹ {totalPaymentAmount.toLocaleString('en-IN')}</h2>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="card bg-warning text-white">
                      <div className="card-body">
                        <h5 className="card-title">Total Penalty Amount</h5>
                        <h2 className="mb-0">₹ {totalPenaltyAmount.toLocaleString('en-IN')}</h2>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="card bg-warning text-white">
                      <div className="card-body">
                        <h5 className="card-title">Total Discount Amount</h5>
                        <h2 className="mb-0">₹ {totalDiscountAmount.toLocaleString('en-IN')}</h2>
                      </div>
                    </div>
                  </div>
                </div>

              )}

              {emiDetails && emiDetails.length > 0 && (
                <Table
                  dataSource={emiDetails}
                  columns={columns}
                  Selection={true}
                />
              )}
            </div>
          </div>

          <div className="modal fade" id="status_modal">
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="d-flex align-items-center">
                    <h4 className="modal-title me-2">Change Status</h4>
                  </div>
                  <button
                    type="button"
                    className="btn-close custom-btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <i className="ti ti-x" />
                  </button>
                </div>
                <form>
                  <div
                    className="contact-grids-tab"
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      marginBottom: "20px",
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmit}
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default PaymentCollection;
